import classnames from "classnames"
import Select from "react-select"
import {
  getReactSelectInputStyles
} from "@pathwright/ui/src/components/form/form-select/ReactSelectInput"
import FieldWrapper from "../form-utils/FieldWrapper"

// Wraps https://github.com/JedWatson/react-select

const SelectInput = function (props) {
  const {
    label,
    value,
    onChange,
    onInputChange,
    searchable = false,
    clearable = false,
    multi = false,
    isSearchable,
    isClearable,
    isMulti,
    isDisabled,
    disabled,
    readOnly,
    position = "bottom",
    styles: stylesProp,
    minimal,
    inline,
    autosize = false,
    children,
    openOnFocus,
    openMenuOnFocus,
    className: classNameProp,
    // FieldWrapper / layout props
    labelWidth,
    topLabel,
    hideStatus,
    hideLabel,
    hideCaution,
    collapse,
    layoutAsColumns,
    helperText,
    tooltip,
    instructions,
    errors,
    error,
    required,
    validating,
    custom,
    stretch,
    inverted,
    style,
    alignCenter,
    alignRight,
    // Removed v1 react-select props
    menuStyle,
    wrapperStyle,
    menuContainerStyle,
    styleType,
    simpleValue,
    labelKey,
    valueKey,
    valueRenderer,
    optionRenderer,
    noResultsText,
    ...selectProps
  } = props

  const className = classnames("SelectInput", classNameProp)
  const selectStyles = getReactSelectInputStyles({
    minimal,
    inline,
    autosize,
    position,
    styles: stylesProp
  })

  return (
    <FieldWrapper {...Object.assign({}, props, { className })}>
      {({ placeholder, onFocus, onBlur }) => {
        return (
          <>
            <Select
              {...selectProps}
              classNamePrefix="Select"
              menuPlacement={position === "top" ? "top" : "bottom"}
              name={typeof label === "string" ? label : selectProps.name}
              value={value ?? null}
              isSearchable={isSearchable ?? searchable}
              isClearable={isClearable ?? clearable}
              isMulti={isMulti ?? multi}
              isDisabled={Boolean(isDisabled || disabled || readOnly)}
              placeholder={placeholder}
              onChange={onChange}
              onInputChange={onInputChange}
              onFocus={onFocus}
              onBlur={onBlur}
              openMenuOnFocus={openMenuOnFocus ?? openOnFocus}
              styles={selectStyles}
            />
            {children}
          </>
        )
      }}
    </FieldWrapper>
  )
}

SelectInput.displayName = "SelectInput"

export default SelectInput
